class TMv_BoothUC_LoginMenus {

	element;

	constructor(element, params) {

		// Save the element for use in other methods
		this.element = element;
		document.addEventListener('click', this.handlePageClick.bind(this));

		// Find all the top_level menu items that have
		this.element.querySelectorAll('.has_children > .TCv_Link').forEach(menu_item => {
			menu_item.addEventListener('click',this.handleNavMenuClick.bind(this));
		});
	}

	/**
	 * When page is clicked this will check if we are clicking off the menu and close it.
	 * @param {Event} event
	 */
	handlePageClick(event) {
		if (!this.element.contains(event.target))
		{
			document.querySelectorAll('.show_login_menu').forEach(el => {
				el.classList.remove('show_login_menu');
			});
		}
	}

	/**
	 * Triggered when an appropriate item is selected
	 * @param {Event} event
	 */
	handleNavMenuClick(event) {
		if (!event.currentTarget.closest('.login_menus_container')) // IGNORE SUBMENUS
		{
			// Link doesn't navigate, shows submenu
			event.preventDefault();

			// Find out if we clicked on the same menu, which should toggle
			let is_same_menu = event.currentTarget.closest('li').classList.contains('show_login_menu');
			// Remove any previous show_login_menu classes
			this.element.querySelectorAll('.show_login_menu').forEach(el => {
				el.classList.remove('show_login_menu');
			});

			// Find the parent LI, add the show_login_menu to the current menu item
			// Only bother if it's a different menu. Otherwise, the removal above handled hiding it (toggle)
			if(!is_same_menu)
			{
				let list_item = event.currentTarget.closest('li');
				list_item.classList.add('show_login_menu');

				// Ensure the focus stays in that popup
				loopFocus(list_item);
			}

		}
	}


}